import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NotFound: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found - ERHR Global</title>
        <meta name="description" content="The page you're looking for doesn't exist. Explore our HR consulting services and find what you need." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center px-4">
        <div className="max-w-lg w-full text-center">
          {/* 404 Illustration */}
          <div className="mb-8">
            <div className="text-8xl font-bold text-primary-500 mb-4">404</div>
            <div className="w-32 h-1 bg-accent-500 mx-auto rounded-full"></div>
          </div>
          
          {/* Error Message */}
          <h1 className="text-3xl font-bold text-neutral-800 mb-4">
            Oops! Page Not Found
          </h1>
          <p className="text-lg text-neutral-600 mb-8">
            The page you're looking for seems to have taken a different career path. 
            Let's help you find your way back to our HR solutions.
          </p>
          
          {/* Navigation Links */}
          <div className="space-y-4 mb-8">
            <Link 
              to="/" 
              className="block w-full bg-primary-500 hover:bg-primary-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200"
            >
              Return to Homepage
            </Link>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Link 
                to="/who-we-are" 
                className="block bg-white hover:bg-neutral-50 text-primary-600 font-medium py-2 px-4 rounded-lg border border-primary-200 transition-colors duration-200"
              >
                About Us
              </Link>
              <Link 
                to="/contact" 
                className="block bg-white hover:bg-neutral-50 text-primary-600 font-medium py-2 px-4 rounded-lg border border-primary-200 transition-colors duration-200"
              >
                Contact Us
              </Link>
            </div>
          </div>
          
          {/* Popular Services */}
          <div className="text-left bg-white rounded-lg p-6 shadow-sm">
            <h2 className="text-lg font-semibold text-neutral-800 mb-4">
              Popular HR Services
            </h2>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/strategic-hr/employee-engagement" 
                  className="text-primary-600 hover:text-primary-700 hover:underline"
                >
                  Employee Engagement Solutions
                </Link>
              </li>
              <li>
                <Link 
                  to="/strategic-hr/performance-management" 
                  className="text-primary-600 hover:text-primary-700 hover:underline"
                >
                  Performance Management
                </Link>
              </li>
              <li>
                <Link 
                  to="/transitional-hr" 
                  className="text-primary-600 hover:text-primary-700 hover:underline"
                >
                  Transitional HR Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/strategic-hr/hr-systems" 
                  className="text-primary-600 hover:text-primary-700 hover:underline"
                >
                  HR Systems Implementation
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Search Suggestion */}
          <div className="mt-6 text-sm text-neutral-500">
            <p>
              Still can't find what you're looking for? 
              <Link to="/contact" className="text-primary-600 hover:underline ml-1">
                Contact our HR experts
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
